/*
 * Exported as source (see package.json) so next.config.mjs can import it
 * during `next typegen` without a prior build. Keep this file dependency-free.
 */
export const EXTENSION_ID = 'mhongonikpobicpbfpeobbdckpicblkh';
export const EXTENSION_ORIGIN = `chrome-extension://${EXTENSION_ID}`;
